import {
  globalAxios,
  backendVersion,
  managerInstance,
  merchantInstance,
} from "@/axios-path.js";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    setManagerMaintain: [],
    addCredit: {},
    setManagerMaintainById: {},
    setPay: []
  },
  mutations: {
    setManagerMaintain(state, data) {
      state.setManagerMaintain = data;
    },
    addCredit(state, data) {
      state.addCredit = data;
    },
    setManagerMaintainById(state, data) {
      state.setManagerMaintainById = data
    },
    setPay(state, data) {
      state.setPay = data;
    }
  },
  actions: {
    async addCreditManager({ commit, dispatch }, credit) {
      let url = backendVersion.version + "/partner/add_credit_manager";
      let payload = {
        user_partner_id: credit.user_partner_id,
        amount: credit.amount
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("setPay", res.data);
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    async fetchManagerMaintain({ commit }, config) {
      let url = backendVersion.version + "/partner/get_list_manager_backoffice";
      return managerInstance
        .get(url, { params: config })
        .then((data) => {
          commit("setManagerMaintain", data.data);
          return data.data;
        })
        .catch((err) => {
          return [];
        });
    },
    async fetchManagerMaintainById({ commit }, id) {
      let url = `${backendVersion.version
        }/partner/get_manager_by_id_backoffice/${id}`;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setManagerMaintainById", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },

  },
  getters: {},
};
